/**
 * Given a chart.js tooltip context and a callback function to apply to the
 * value, returns a formatted label for the tooltip.
 * @param context
 * @param callback
 * @returns {string}
 */
const formatChartTooltipLabel = ({
  dataset: {
    label = '',
  } = {},
  parsed: {
    y = null,
  } = {},
}, callback) => (y !== null
  ? `${label}: ${callback(y)}`
  : `${label}: N/A`);

export default formatChartTooltipLabel;
